import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const trustFeatures = [
    {
      icon: 'Shield',
      title: 'Secure & Encrypted',
      description: 'Your data is protected with SSL encryption'
    },
    {
      icon: 'Award',
      title: 'Certified Travel Partner',
      description: 'Authorized by Tamil Nadu Tourism Board'
    },
    {
      icon: 'Users',
      title: '50,000+ Happy Travelers',
      description: 'Join thousands of satisfied customers'
    }
  ];

  const securityBadges = [
    {
      name: 'SSL Secured',
      icon: 'Lock',
      color: 'text-success'
    },
    {
      name: 'GDPR Compliant',
      icon: 'ShieldCheck',
      color: 'text-primary'
    },
    {
      name: 'ISO Certified',
      icon: 'Award',
      color: 'text-accent'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Trust Features */}
      <div className="grid grid-cols-1 gap-4">
        {trustFeatures.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3 p-3 bg-muted/50 rounded-lg">
            <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={feature.icon} size={16} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-foreground">{feature.title}</h4>
              <p className="text-xs text-muted-foreground mt-1">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Security Badges */}
      <div className="border-t border-border pt-4">
        <div className="flex items-center justify-center space-x-6">
          {securityBadges.map((badge, index) => (
            <div key={index} className="flex items-center space-x-1">
              <Icon name={badge.icon} size={14} className={badge.color} />
              <span className="text-xs font-medium text-muted-foreground">
                {badge.name}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Customer Support */}
      <div className="text-center p-4 bg-secondary/5 rounded-lg border border-secondary/10">
        <div className="flex items-center justify-center space-x-2 mb-2">
          <Icon name="Headphones" size={16} className="text-secondary" />
          <span className="text-sm font-medium text-secondary">24/7 Support</span>
        </div>
        <p className="text-xs text-muted-foreground">
          Need help? Our support team is available round the clock
        </p>
        <button className="text-xs text-primary hover:text-primary/80 font-medium mt-2">
          Contact Support
        </button>
      </div>
    </div>
  );
};

export default TrustIndicators;